<div class="flex gap-2">
  @for (item of navItems; track item) {
    <p-button
      [label]="item.label"
      [icon]="item.icon"
      severity="secondary"
      [text]="true"
      [routerLink]="item.routerLink"
      routerLinkActive="p-button-primary"
      [routerLinkActiveOptions]="{exact: false}">
    </p-button>
  }
</div>